module.exports = __webpack_public_path__ + "img/standard.67be241c.png";